<template>
  <div class="pin-code-container">
    <h2 class="text-2xl font-semibold mb-8 text-center">Введите ПИН-код</h2>

    <!-- Отображение введенных цифр -->
    <div class="flex justify-center gap-6 mb-8">
      <template v-for="(digit, index) in 4" :key="index">
        <div
          class="w-12 h-12 rounded-full border border-gray-400 flex items-center justify-center transition-all duration-200"
          :class="index < pinCode.length ? '' : 'border-white bg-transparent'"
        >
          <span v-if="index < pinCode.length" class="text-blue-800 text-3xl">●</span>
        </div>
      </template>
    </div>

    <!-- Цифровая клавиатура -->
    <div class="grid grid-cols-3 gap-6">
      <!-- Цифры 1-9 -->
      <template v-for="n in 9" :key="n">
        <button
          @click="addDigit(n.toString())"
          class="number-button border border-gray-400"
        >
          <div class="text-3xl">{{ n }}</div>
        </button>
      </template>

      <!-- Кнопка для стирания -->
      <button
        @click="clearPinCode()"
        class="number-button text-xl font-bold border border-gray-400"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" />
        </svg>
      </button>

      <!-- Цифра 0 -->
      <button
        @click="addDigit('0')"
        class="number-button border border-gray-400"
      >
        <div class="text-3xl">0</div>
      </button>

      <!-- Кнопка для подтверждения -->
      <button
        @click="submitPinCode"
        class="number-button border border-gray-400"
        :class="{'opacity-50 cursor-not-allowed': pinCode.length !== 4, 'bg-green-400 hover:bg-green-500': pinCode.length === 4}"
        :disabled="pinCode.length !== 4"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
      </button>
    </div>

    <!-- Сообщение об ошибке -->
    <div v-if="error" class="text-red-900 mt-6 text-center p-3 border border-red-900 bg-red-900 bg-opacity-30 rounded">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 inline mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
      {{ error }}
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth';

export default {
  name: 'PinCodeInput',
  props: {
    userId: {
      type: [Number, String],
      required: true
    },
    moduleRedirectId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      pinCode: '',
      error: null,
      authStore: useAuthStore()
    };
  },
  methods: {
    addDigit(digit) {
      if (this.pinCode.length < 4) {
        this.pinCode += digit;

        if (this.pinCode.length === 4) {
          this.submitPinCode();
        }
      }
    },
    clearPinCode() {
      this.pinCode = '';
      this.error = null;
    },
    submitPinCode() {
      if (this.pinCode.length !== 4) {
        return;
      }

      this.error = null;

      this.authStore.loginWithPin(this.userId, this.pinCode, this.moduleRedirectId)
        .then(data => {
          window.location.href = data.redirect_url;
        })
        .catch(error => {
          console.error('Ошибка авторизации:', error);
          this.error = error.response?.data?.message || 'Неверный ПИН-код';
          this.pinCode = '';
        });
    }
  }
};
</script>

<style scoped>
.pin-code-container {
  max-width: 320px;
  margin: 0 auto;
}

.number-button {
  width: 100%;
  aspect-ratio: 1;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: rgb(0, 0, 0);
  font-weight: 500;
}
</style>
